import { Injectable } from '@angular/core';
import { ImageEditingType, QuestionEditingOptions } from '@examdojo/models/question-editor';
import { QuestionItemsFormService } from '@examdojo/question';
import { ReferenceQuestionQuery } from '@examdojo/reference-question';
import { BehaviorSubject } from 'rxjs';
import { ReferenceQuestionEditorService } from './reference-question-editor.service';

@Injectable()
export class ReferenceQuestionEditorItemsFormService extends QuestionItemsFormService {
  constructor(
    private readonly referenceQuestionEditorService: ReferenceQuestionEditorService,
    private readonly referenceQuestionQuery: ReferenceQuestionQuery,
  ) {
    super();
  }

  readonly form = this.referenceQuestionEditorService.referenceQuestionForm.controls.question_items;

  readonly questionItems$ = this.referenceQuestionEditorService.questionItems$;

  readonly editingOptions$ = new BehaviorSubject<QuestionEditingOptions | null>({
    allowImageEditing: [ImageEditingType.Original, ImageEditingType.Generated],
    allowQuestionEditing: true,
    allowMarkschemeEditing: true,
    allowMcqEditing: true,
    allowMarkschemeStructureEditing: true,
    allowMcqStructureEditing: true,
    hideBadges: false,
    allowQuestionStructureEditing: true,
    showMcqMetadata: true,
  });

  override readonly generateSolutionQuestionId$ = this.referenceQuestionQuery.selectActiveId();
}
